module.exports = __webpack_public_path__ + "static/img/9.50edce0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/eng/9.png
// module id = +O9V
// module chunks = 0